import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

interface CartQuantityStepperProps {
  quantity: number;
  disabled?: boolean;
  size?: 'small' | 'medium';
  onDecrease: () => void;
  onIncrease: () => void;
  decreaseLabel?: string;
  increaseLabel?: string;
}

const CartQuantityStepper: React.FC<CartQuantityStepperProps> = ({
  quantity,
  disabled = false,
  size = 'medium',
  onDecrease,
  onIncrease,
  decreaseLabel = 'Disminuir cantidad',
  increaseLabel = 'Aumentar cantidad',
}) => {
  const iconFontSize = size === 'small' ? 16 : 18;

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        border: 1,
        borderColor: 'divider',
        borderRadius: 1,
        overflow: 'hidden',
      }}
    >
      <IconButton
        size="small"
        aria-label={decreaseLabel}
        disabled={disabled || quantity <= 0}
        onClick={onDecrease}
        sx={{ borderRadius: 0, px: size === 'small' ? 0.5 : 0.75 }}
      >
        <RemoveIcon sx={{ fontSize: iconFontSize }} />
      </IconButton>
      <Typography
        variant="body2"
        fontWeight={600}
        sx={{
          minWidth: size === 'small' ? 28 : 36,
          textAlign: 'center',
          userSelect: 'none',
          px: 0.5,
        }}
      >
        {quantity}
      </Typography>
      <IconButton
        size="small"
        aria-label={increaseLabel}
        disabled={disabled}
        onClick={onIncrease}
        sx={{ borderRadius: 0, px: size === 'small' ? 0.5 : 0.75 }}
      >
        <AddIcon sx={{ fontSize: iconFontSize }} />
      </IconButton>
    </Box>
  );
};

export default CartQuantityStepper;
